import React, { useContext } from 'react';

import { Box, Grow } from '@material-ui/core';
import { updateTaskAction, removeTaskAction } from 'actions/task';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { selectAddToAgendaState } from 'selectors/addToAgendaStateSelector';

import NoGoalsImage from 'assets/images/illustrations/no_goals.png';

import { TASK_TYPES_2, MESH_LIST_TABS } from 'constants/ProjectConstants';
import { sendOpenedKRPanelEvent } from 'constants/mixpanelHelper';

import { showTaskDetails } from 'services/taskDetails';

import LoadMore from '../LoadMore';
import MeshListContext from '../MeshListContext';
import TasksGoalsContainer from '../TasksGoalsContainer';
import NoTasksComponent from '../tasks/NoTasksComponent';
import GoalListItem from './GoalListItem';

export default function Goals({
  goals,
  pageType,
  employee,
  timeBoundPeriod = null,
  setIsOpenCreateGoalPanel = () => {},
  source = '',
}) {
  const { selectedTab, apiPaginationMeta, selectedTeamsPageView = null, dispatch } = useContext(MeshListContext);
  const reduxDispatch = useDispatch();

  const { showAddToAgenda } = useSelector(selectAddToAgendaState, shallowEqual);

  const showDetails = (e, taskId, type) => {
    if (e) e.stopPropagation();
    reduxDispatch(
      showTaskDetails({
        taskIds: [taskId],
        onDelete: () => {
          dispatch(removeTaskAction(taskId));
        },
        onUpdate: (task) => {
          if (task) dispatch(updateTaskAction(task));
        },
        employee,
        type,
      })
    );
    sendOpenedKRPanelEvent({ eventProperties: { source } });
  };

  const isGoalsTabSelected = selectedTab === MESH_LIST_TABS.goal.id || selectedTeamsPageView === TASK_TYPES_2.goal;

  if (goals?.length === 0 && isGoalsTabSelected) {
    return (
      <NoTasksComponent
        img={NoGoalsImage}
        heading="No goals yet"
        subHeading="Create Goals, align with your team, and measure your progress here."
        onButtonClick={() => setIsOpenCreateGoalPanel(true)}
        buttonText="Add Goal"
      />
    );
  }

  return isGoalsTabSelected ? (
    <TasksGoalsContainer>
      {goals.map((goal, index, goalArray) => {
        const lastItem = index + 1 === goalArray.length;
        return (
          <Grow style={{ marginBottom: lastItem ? '50px' : 0 }} in key={`activeGoals${goal.id || goal.key}`}>
            <GoalListItem
              key={`goal${goal.id}`}
              goal={goal}
              onClickHandler={(e) => showDetails(e, goal.id, goal.type)}
              showAddToAgenda={showAddToAgenda}
            />
          </Grow>
        );
      })}
      {apiPaginationMeta?.hasMore && (
        <div>
          <Box position="absolute" bottom={0} width="100%" borderTop="1px solid lightgrey" textAlign="center">
            <LoadMore type={TASK_TYPES_2.goal} pageType={pageType} timeBoundPeriod={timeBoundPeriod} />
          </Box>
        </div>
      )}
    </TasksGoalsContainer>
  ) : null;
}
